// Copyright (C) 2020 Intel Corporation
//
// SPDX-License-Identifier: MIT

import { connect } from 'react-redux';
import ForbiddenPageComponent from 'components/forbidden-page/forbidden-page';

export default connect()(ForbiddenPageComponent);
